import { getOriginalSize as v } from "@rstudio/dom-v2";
import { getAngle as y, toRadians as c } from "@rstudio/util-v2";
const M = (r, e) => {
  if (e.length < 2)
    return;
  r.beginPath(), r.moveTo(e[0].x, e[0].y);
  const t = e.length - 1;
  for (let a = 1; a < t - 1; ++a) {
    const l = (e[a].x + e[a + 1].x) / 2, h = (e[a].y + e[a + 1].y) / 2;
    r.quadraticCurveTo(e[a].x, e[a].y, l, h);
  }
  r.quadraticCurveTo(e[t - 1].x, e[t - 1].y, e[t].x, e[t].y), r.stroke(), r.closePath();
}, R = (r, e) => {
  e.length < 2 || (r.beginPath(), r.moveTo(e[0].x, e[0].y), r.lineTo(e[1].x, e[1].y), r.stroke(), r.closePath());
}, B = (r, e) => {
  e.length < 2 || (r.fillRect(e[0].x, e[0].y, e[1].x - e[0].x, e[1].y - e[0].y), r.strokeRect(e[0].x, e[0].y, e[1].x - e[0].x, e[1].y - e[0].y));
}, W = (r, e, t = !0) => {
  if (e.length < 2)
    return;
  const a = (e[1].x - e[0].x) / 2, l = (e[1].y - e[0].y) / 2, h = t ? Math.max(Math.abs(a), Math.abs(l)) : Math.min(Math.abs(a), Math.abs(l));
  r.beginPath(), r.arc(e[0].x + a, e[0].y + l, h, 0, 2 * Math.PI, !1), r.fill(), r.stroke();
}, L = (r, e) => {
  if (e.length < 2)
    return;
  const t = (e[1].x - e[0].x) / 2, a = (e[1].y - e[0].y) / 2;
  r.beginPath(), r.ellipse(e[0].x + t, e[0].y + a, Math.abs(t), Math.abs(a), 0, 0, 2 * Math.PI), r.fill(), r.stroke();
}, k = (r, e, t = 20) => {
  r.save(), r.translate(e[1].x, e[1].y);
  const a = y(e[0].x, e[0].y, e[1].x, e[1].y);
  r.rotate(c(a - 90)), r.beginPath(), r.moveTo(0, 0), r.lineTo(-t, -t * 2), r.lineTo(t, -t * 2), r.closePath(), r.fill(), r.stroke(), r.restore();
}, S = (r, e, t = 20) => {
  e.length < 2 || (R(r, e), k(r, e, t));
}, i = (r, e, t, a, l, h, n, f) => {
  r.beginPath(), r.moveTo(e + h.leftTop, t), r.lineTo(e + a - h.rightTop, t), r.quadraticCurveTo(e + a, t, e + a, t + h.rightTop), r.lineTo(e + a, t + l - h.rightBottom), r.quadraticCurveTo(e + a, t + l, e + a - h.rightBottom, t + l), r.lineTo(e + h.leftBottom, t + l), r.quadraticCurveTo(e, t + l, e, t + l - h.leftBottom), r.lineTo(e, t + h.leftTop), r.quadraticCurveTo(e, t, e + h.leftTop, t), r.closePath(), f && r.stroke(), n && r.fill();
}, D = (r, e, t) => {
  if (e.width && e.height) {
    if (r.save(), t)
      if (r.lineWidth = t.lineWidth || r.lineWidth, r.fillStyle = t.fillStyle || r.fillStyle, r.strokeStyle = t.strokeStyle || r.strokeStyle, t.lineDash && r.setLineDash(t.lineDash), t.radius) {
        const a = t.fillStyle !== void 0, l = !a || t.strokeStyle !== void 0;
        i(
          r,
          e.left,
          e.top,
          e.width,
          e.height,
          {
            leftTop: t.radius,
            rightTop: t.radius,
            leftBottom: t.radius,
            rightBottom: t.radius
          },
          a,
          l
        );
      } else
        t.fillStyle && r.fillRect(e.left, e.top, e.width, e.height), t.lineWidth && r.strokeRect(e.left, e.top, e.width, e.height);
    r.restore();
  }
}, I = (r, e, t, a, l, h = { vertical: !1, horizontal: !1 }) => {
  r.save(), r.beginPath(), l && (i(r, a.left, a.top, a.width, a.height, l, !1, !1), r.clip());
  let n = t ? { ...t } : void 0;
  if (!n) {
    const f = v(e);
    n = {
      left: 0,
      top: 0,
      width: f.width,
      height: f.height
    };
  }
  h.horizontal && (r.translate(a.left + a.width + a.left, 0), r.scale(-1, 1), n.left = v(e).width - (n.left + n.width)), h.vertical && (r.translate(0, a.top + a.height + a.top), r.scale(1, -1), n.top = v(e).height - (n.top + n.height)), r.drawImage(
    e,
    n.left,
    n.top,
    n.width,
    n.height,
    a.left,
    a.top,
    a.width,
    a.height
  ), r.restore();
}, A = (r, e, t, a, l, h, n, f, g = !1) => {
  r.save(), r.beginPath(), r.rect(l, h, n, f), r.clip(), r.fillText(e, t, a), g && r.strokeText(e, t, a), r.restore();
}, G = () => {
  const r = document.createElement("canvas").getContext("webgl");
  if (!r)
    return {
      error: "no webgl"
    };
  const e = r.getExtension("WEBGL_debug_renderer_info");
  return e ? {
    vendor: r.getParameter(e.UNMASKED_VENDOR_WEBGL),
    renderer: r.getParameter(e.UNMASKED_RENDERER_WEBGL)
  } : {
    error: "no WEBGL_debug_renderer_info"
  };
}, q = () => {
  const r = document.createElement("canvas");
  if (r) {
    let e = !0;
    const t = r.getContext("webgl");
    if (t instanceof WebGLRenderingContext) {
      const a = t.getExtension("WEBGL_debug_renderer_info");
      if (a) {
        const l = t.getParameter(a.UNMASKED_RENDERER_WEBGL);
        typeof l == "string" && (e = !l.toLowerCase().includes("swiftshader"));
      }
    }
    return r.remove(), e;
  }
  return !1;
}, s = (r, e, t, a, l, h, n = 1, f = "") => {
  const g = t - e, o = l - a, b = e + g / 2, E = a + o / 2, u = g * n, m = o * n;
  let w = null;
  if (r && g > 0 && o > 0) {
    const d = document.createElement("canvas"), T = d.getContext("2d");
    d.width = u, d.height = m, T && (T.drawImage(r, e, a, g, o, 0, 0, u, m), w = T.createPattern(d, h), d.remove());
  }
  return {
    pattern: w,
    centerX: b,
    centerY: E,
    width: u,
    height: m,
    tag: f
  };
};
export {
  A as clipTextToRect,
  S as drawArrow,
  k as drawArrowhead,
  W as drawCircle,
  L as drawEllipse,
  M as drawFreeLine,
  I as drawImage,
  R as drawLine,
  B as drawRect,
  D as drawRectEx,
  i as drawRoundedRect,
  G as getVideoCardInfo,
  q as isHardwareAccelerationEnabled,
  s as makePattern
};
//# sourceMappingURL=index.es.js.map
